import { Contract2Diagnosesicherheit } from '../../mdqx-graphql-types';

export class Contract2DiagnosesicherheitEntity {
    public static readonly GqlFields = 'id opsCode contractId diagnosesicherheitId';

    public Id: number;
    public OpsCode: string;
    public ContractId: number;
    public DiagnosesicherheitId: number;

    constructor(contract2DiagnosesicherheitType: Contract2Diagnosesicherheit | null) {
        if (
            contract2DiagnosesicherheitType &&
            contract2DiagnosesicherheitType.contractId != null &&
            contract2DiagnosesicherheitType.diagnosesicherheitId != null &&
            contract2DiagnosesicherheitType.id != null &&
            contract2DiagnosesicherheitType.opsCode != null
        ) {
            this.Id = contract2DiagnosesicherheitType.id;
            this.OpsCode = contract2DiagnosesicherheitType.opsCode;
            this.ContractId = contract2DiagnosesicherheitType.contractId;
            this.DiagnosesicherheitId = contract2DiagnosesicherheitType.diagnosesicherheitId;
        } else {
            console.error(
                'received broken Contract2DiagnosesicherheitType',
                contract2DiagnosesicherheitType,
            );
            throw Error();
        }
    }
}
